import styled from 'styled-components';
import rightArrow from '../../images/policy/right-arrow.svg';
import OpdBackground from '../../images/newInsurerPage/OpdBg.svg';
import GmcBackground from '../../images/newInsurerPage/GmcBg.svg';
import PurpleArrow from '../../images/newInsurerPage/purpleArrow.svg';
import lightBlueArrow from '../../images/newInsurerPage/lightBlueArrow.svg';
import Tappable from 'react-tappable/lib/Tappable';

const TappableCard = styled(Tappable)``;
const CardBody = styled.div`
  display: flex;
  //   justify-content: space-evenly;
  align-items: center;
  background: ${(props) => `url(${props.bgSvg})`},
    ${(props) => `${props.bgColor}`};
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  text-align: center;
  border: ${(props) => (props.borderColor ? '1px solid' : 'none')};
  border-image: ${(props) =>
    props.borderColor ? `${props.borderColor}` : 'none'};
  border-radius: 12px;
  padding: 15px 28px 15px 20px;
  margin-bottom: 1rem;
`;

const CardIcon = styled.img`
  align-self: auto;
  //height: 40px;
  width: 50px;
  border-radius: 5px;
  padding: 0.4rem;
`;

const CardDetails = styled.div`
  padding: 0px 18px 0px 20px;
  text-align: left;
  flex: 1;
`;

const CardTitle = styled.p`
  font-family: Inter;
  font-size: 16px;
  line-height: 21px;
  font-weight: 600;
  white-space: pre-wrap;
  margin-bottom: 8px;
`;

const CardSubtitle = styled.p`
  font-size: 12px;
  font-family: Inter;
  line-height: 15px;
  font-weight: 600;
  white-space: pre-wrap;
  color: ${(props) => props.titleColor};
  line-height: 20px;
`;
const CardSubtitleSpan = styled.span`
  font-size: 12px;
  font-family: Inter;
  line-height: 15px;
  font-weight: 600;
  white-space: pre-wrap;
  color: ${(props) => props.titleColor};
  line-height: 20px;
`;

const CardSubtitleType2 = styled.p`
  font-family: Inter;
  font-size: 10px;
  line-height: 15px;
  font-weight: 600;
  white-space: pre-wrap;
  color: #171616;
  line-height: 20px;
`;

const RightArrow = styled.img`
  filter: ${(props) => (props.filter ? `${props.filter}` : 'none')};
  color: ${(props) => (props.color ? `${props.color}` : 'none')};
`;

const getBackground = (ThemeKey) => {
  switch (ThemeKey) {
    case 'opd-policy-1':
      return OpdBackground;
    case 'gmc-policy':
      return GmcBackground;
    default:
      return GmcBackground;
  }
};
const getBackgroundColor = (ThemeKey) => {
  switch (ThemeKey) {
    case 'opd-policy-1':
      return 'linear-gradient(133deg, #FFF 0%, #EDE3FF 100%)';
    case 'gmc-policy':
      return 'linear-gradient(136deg, #E5F4FF 0%, #C0E8FF 100%)';
    default:
      return 'linear-gradient(136deg, #E5F4FF 0%, #C0E8FF 100%)';
  }
};
const getTextColor = (ThemeKey) => {
  switch (ThemeKey) {
    case 'opd-policy-1':
      return '#ffbb00';
    case 'gmc-policy':
      return '#3880B4';
    default:
      return '#3880B4';
  }
};
const getArrow = (ThemeKey) => {
  switch (ThemeKey) {
    case 'opd-policy-1':
      return PurpleArrow;
    case 'gmc-policy':
      return lightBlueArrow;
    default:
      return lightBlueArrow;
  }
};

const NewBenefitsCard = (props) => {
  console.log('props are ', props);
  return (
    <Tappable onTap={props.onTap}>
      <CardBody
        // onClick={props.onTap}
        bgSvg={getBackground(props.data.themeKey)}
        borderColor=""
        bgColor={getBackgroundColor(props.data.themeKey)}
      >
        <IconWrapper>
          <CardIcon src={props.data.insurerLogo} alt="icon" />
        </IconWrapper>

        <CardDetails>
          <CardTitle>{props.data.title}</CardTitle>
          <CardSubtitle titleColor={getTextColor(props.data.themeKey)}>
            {props.data.subtitle}
          </CardSubtitle>
          <CardSubtitleType2>
            Sum Insured:{' '}
            <CardSubtitleSpan titleColor={getTextColor(props.data.themeKey)}>
              {props.data.sumInsured}
            </CardSubtitleSpan>
          </CardSubtitleType2>
          <CardSubtitleType2>
            Exp Date: {props.data.terminatedAt}
          </CardSubtitleType2>
        </CardDetails>
        <RightArrow
          src={getArrow(props.data.themeKey)}
          //color={getArrowColor(props.data.themeKey)}
          filter={props.filter}
        />
      </CardBody>
    </Tappable>
  );
};

export default NewBenefitsCard;

const IconWrapper = styled.div`
  margin-top: 0.3rem;
  height: 45px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: white;
  border-radius: 5px;
  align-self: flex-start;
`;
